module.exports = __webpack_public_path__ + "img/cancel.6eaa9a74.svg";